import BankTransferConstants from '@/constants/BankTransferConstants';

const SUBMIT_ERROR_KEY_GENERIC = 'Bookings.SettlePayment.BankTransferSubmitFailed';
const SUBMIT_ERROR_KEYS = {
	[BankTransferConstants.ERROR_CODES.OPEN_BANK_TRANSFER_REQUEST]: 'Bookings.SettlePayment.BankTransferOpenRequestExists',
	[BankTransferConstants.ERROR_CODES.PAYMENT_ALREADY_ON_REQUEST]: 'Bookings.SettlePayment.BankTransferPaymentAlreadyOnRequest',
};
// Same messages naming the refused booking; used when the 409 carries its `short_id`.
const SUBMIT_ERROR_KEYS_FOR_BOOKING = {
	[BankTransferConstants.ERROR_CODES.OPEN_BANK_TRANSFER_REQUEST]: 'Bookings.SettlePayment.BankTransferOpenRequestExistsForBooking',
	[BankTransferConstants.ERROR_CODES.PAYMENT_ALREADY_ON_REQUEST]:
		'Bookings.SettlePayment.BankTransferPaymentAlreadyOnRequestForBooking',
};

function copyToClipboard(value) {
	if (navigator?.clipboard) {
		navigator.clipboard.writeText(value).catch((err) => {
			console.error('Failed to copy text: ', err);
		});
	}
}

// -> { key, params } for `t(key, params)`.
function getSubmitErrorMessage(errorCode, shortId) {
	if (shortId && SUBMIT_ERROR_KEYS_FOR_BOOKING[errorCode]) {
		return { key: SUBMIT_ERROR_KEYS_FOR_BOOKING[errorCode], params: { shortId } };
	}

	return { key: SUBMIT_ERROR_KEYS[errorCode] || SUBMIT_ERROR_KEY_GENERIC, params: undefined };
}

export { copyToClipboard, getSubmitErrorMessage };
